var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 21,
    viewBox: "0 0 41 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1041 12.6295C11.4991 12.6295 12.63 11.4986 12.63 10.1036C12.63 8.70853 11.4991 7.57764 10.1041 7.57764C8.70902 7.57764 7.57812 8.70853 7.57812 10.1036C7.57812 11.4986 8.70902 12.6295 10.1041 12.6295Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1558 12.6295C21.5508 12.6295 22.6817 11.4986 22.6817 10.1036C22.6817 8.70853 21.5508 7.57764 20.1558 7.57764C18.7608 7.57764 17.6299 8.70853 17.6299 10.1036C17.6299 11.4986 18.7608 12.6295 20.1558 12.6295Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2076 12.6295C31.6026 12.6295 32.7335 11.4986 32.7335 10.1036C32.7335 8.70853 31.6026 7.57764 30.2076 7.57764C28.8125 7.57764 27.6816 8.70853 27.6816 10.1036C27.6816 11.4986 28.8125 12.6295 30.2076 12.6295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflow);
export default __webpack_public_path__ + "static/media/overflow.dbee5f228336f0e23d5e1cadbd668a22.svg";
export { ForwardRef as ReactComponent };